<template>
  <div 
    class="row d-flex justify-content-between align-items-center"
  >
    <div class="justify-content-center col-md-12 p-5">
      <div class="text-center">
        <i class="uil uil-image-v font-size-100 text-center" style="font-size: 120px; color: #BDBDBD;" :horizontalFlip="true"></i>
        <h3 class="col-md-12 text-center">Apply with New {{ moduleName }}</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</p>
        <b-button class="candidate-button" size="sm" @click="onClick('modeUpload', true)">
          New {{ moduleName }}
        </b-button>
        <div class="text-center my-4 text-line"><span>Or apply with</span></div>
        <b-button class="candidate-button button-white" size="sm" @click="onClick('modeSelect')">
          Existing {{ moduleName }}
          <!-- {{ $t('job.submit_window.action.select_candidate') }} -->
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    moduleName() {
      const isCandidate = !this.role_modules.some(item => item.value == 'job.submit_candidate')
      return isCandidate ? "Application" : "Candidate"
    }
  },
  methods: {
    onClick(method, bool) {
      this.$emit('onClick', { method, bool })
    }
  }
}
</script>
<style>
.body-content {
  position: absolute;
  width: 471px;
  height: 422px;
  left: 909px;
  top: 301px;
}
.custom-image {
  position: absolute;
  width: 120px;
  height: 120px;
  /* left: calc(50% - 120px/2 + 425px); */
  top: calc(50% - 120px/2 - 151px);

  /* Gray 4 */

  background: #BDBDBD;
}

.text-line {
  width: 100%; 
  text-align: center; 
  border-bottom: 1px solid #000; 
  line-height: 0.1em;
  margin: 10px 0 20px; 
}   

.text-line span { 
  background:#ffffff;
  padding:0 10px; 
}

</style>